import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This example demonstrates how ray tracing works. When moving your cursor in the room, an arrow will indicate the launching direction of the particle. Now click the mouse button to start particles into this direction and observe how the particle travels. You can repeat this by moving and clicking the mouse. Finally, you can press ‘Start Particles’ which will start shooting 1,000 particles in random directions. Notice how the impulse response on the right side will be generated by collecting the particle energy and arrival times in a histogram.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0309/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
